<!-- src/app/features/register/register.component.html -->

@if (isInviteFlow && !tokenValid) {
  <div class="container-fluid d-flex align-items-center justify-content-center min-vh-100 bg-light">
    <div class="col-md-6 text-center">
      <h3 class="text-danger">Invalid or expired invite link.</h3>
      <p>Please contact your clinic administrator to request a new invite.</p>
    </div>
  </div>
} @else if (!isRegisterSucessfully) {
  <div
    class="container-fluid d-flex align-items-center justify-content-center min-vh-100 bg-light"
  >
    <div class="col-md-8 col-lg-6">
      <div class="text-center mb-4">
        <img
          src="https://www.sigvaris.com/globalassets/_div/sig9000_sigvaris_group_160th_logo_dual_horizontal_darkblue_rgb.svg?ref=FD8B1C8BB4"
          alt="Sigvaris Group Logo"
          class="img-fluid mb-3"
          style="max-width: 200px; height: 120px"
        />
      </div>
      <div class="card custom-card">
        <div class="card-body" style="padding-left: 25px; padding-right: 25px">
          <h2 class="card-title text-center mb-4">Register</h2>

          <!-- Invite context banner (only in invite flow) -->
          @if (isInviteFlow) {
            <div class="alert alert-info mb-4">
              You received an invite from <strong>{{ inviteClinicName }}</strong> as <strong>Therapist</strong>.
              Fields marked as <strong>Pre-filled</strong> are already set and cannot be changed.
            </div>
          } @else {
            <label>
              Please contact Sigvaris US Customer Services to obtain your Clinic ID.
            </label>
            <p></p>
          }

          <form
            [formGroup]="registerForm"
            (ngSubmit)="onSubmit()"
            [class.disabled]="isLoading"
            autocomplete="off"
          >
            <!-- Row 1: Clinic ID / Password / Confirm Password -->
            <div class="row">
              <div class="col-md-4 mb-3">
                <label for="clinicId" class="form-label">
                  Clinic ID*
                  @if (isInviteFlow) { <span class="badge bg-secondary ms-1">Pre-filled</span> }
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="clinicId"
                  formControlName="clinicId"
                  placeholder="Enter Clinic ID"
                />
                @if (registerForm.get("clinicId")?.touched && registerForm.get("clinicId")?.invalid) {
                  <div class="text-danger">Clinic ID is required.</div>
                }
              </div>
              <div class="col-md-4 mb-3">
                <label for="password" class="form-label">Password*</label>
                <input
                  type="password"
                  class="form-control"
                  id="password"
                  formControlName="password"
                  placeholder="Enter Password"
                />
                @if (registerForm.get("password")?.touched && registerForm.get("password")?.invalid) {
                  <div class="text-danger">
                    Password is required and must be at least 8 characters.
                  </div>
                }
              </div>
              <div class="col-md-4 mb-3" style="float: right">
                <label for="confirmPassword" class="form-label">Confirm Password*</label>
                <input
                  type="password"
                  class="form-control"
                  id="confirmPassword"
                  formControlName="confirmPassword"
                  placeholder="Enter Password"
                />
                @if (registerForm.get("confirmPassword")?.touched && registerForm.get("confirmPassword")?.invalid) {
                  <div class="text-danger">
                    Password is required and must be at least 8 characters.
                  </div>
                }
                <div
                  *ngIf="registerForm.errors?.mismatch && registerForm.get('confirmPassword')?.touched"
                  class="text-danger mb-3"
                >
                  Passwords do not match.
                </div>
              </div>
            </div>

            <!-- Row 2: Name / Organization -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="name" class="form-label">
                  Name*
                  @if (isInviteFlow) { <span class="badge bg-secondary ms-1">Pre-filled</span> }
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  formControlName="name"
                  placeholder="Enter Name"
                />
                @if (registerForm.get("name")?.touched && registerForm.get("name")?.invalid) {
                  <div class="text-danger">Name is required.</div>
                }
              </div>
              <div class="col-md-6 mb-3">
                <label for="organization" class="form-label">Organization*</label>
                <input
                  type="text"
                  class="form-control"
                  id="organization"
                  formControlName="organization"
                  placeholder="Enter Organization"
                />
                @if (registerForm.get("organization")?.touched && registerForm.get("organization")?.invalid) {
                  <div class="text-danger">Organization is required.</div>
                }
              </div>
            </div>

            <!-- Row 3: Phone -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="phone" class="form-label">Phone*</label>
                <input
                  type="text"
                  class="form-control"
                  id="phone"
                  formControlName="phone"
                  placeholder="Enter Phone Number"
                />
                @if (registerForm.get("phone")?.touched && registerForm.get("phone")?.invalid) {
                  <div class="text-danger">Phone number is required.</div>
                }
              </div>
            </div>

            <!-- Email -->
            <div class="mb-3">
              <label for="email" class="form-label">
                Email*
                @if (isInviteFlow) { <span class="badge bg-secondary ms-1">Pre-filled</span> }
              </label>
              <input
                type="email"
                class="form-control"
                id="email"
                formControlName="email"
                placeholder="Enter Email"
              />
              @if (registerForm.get("email")?.touched && registerForm.get("email")?.invalid) {
                <div class="text-danger">Valid email is required.</div>
              }
            </div>

            <!-- Agree to Terms -->
            <div class="mb-3 form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="agreeTerms"
                formControlName="agreeTerms"
              />
              <label class="form-check-label" for="agreeTerms">
                SIGVARIS will use my personal data to process and setup my
                account. I agree with SIGVARIS' privacy statement provided
                <a target="_blank" href="https://www.sigvaris.com/en-us/information/legal">here</a>.
              </label>
              <p></p>
              <p>
                Contact Details / Customer Services: Tel. 800-322-7744 ext 1 or
                email: us_custom orders&#64;sigvaris.com
              </p>
              @if (
                registerForm.get("agreeTerms")?.invalid &&
                (registerForm.get("agreeTerms")?.touched || registerForm.get("agreeTerms")?.dirty)
              ) {
                <div class="text-danger">You must agree to the terms.</div>
              }
            </div>

            <div
              *ngIf="registerForm.get('password')?.errors?.['passwordStrength']"
              class="text-danger"
            >
              <p>Password must contain:</p>
              <ul>
                <li *ngIf="!registerForm.get('password')?.errors?.['passwordStrength'].hasUpperCase">
                  At least one uppercase letter.
                </li>
                <li *ngIf="!registerForm.get('password')?.errors?.['passwordStrength'].hasLowerCase">
                  At least one lowercase letter.
                </li>
                <li *ngIf="!registerForm.get('password')?.errors?.['passwordStrength'].hasNumeric">
                  At least one number.
                </li>
                <li *ngIf="!registerForm.get('password')?.errors?.['passwordStrength'].hasSpecialChar">
                  At least one special character.
                </li>
              </ul>
            </div>

            <!-- Register Button -->
            <button
              [disabled]="isLoading"
              (click)="onSubmit()"
              class="mt-4 mb-4 j7 j8 an j9 ja ft fu bn fj fk fv fw fl fm am e8 b3 e6 bt bu jb jc ju je q r s ds bw cv by cx c2"
              style="width: 100%; height: 50px"
            >
              {{ isLoading ? 'Registering…' : 'Register' }}
            </button>

            @if (errorMessage) {
              <div class="alert alert-danger">{{ errorMessage }}</div>
            }
          </form>
        </div>
      </div>
    </div>
  </div>
  @if (isLoading) {
    <div
      id="loading"
      class="position-absolute top-50 start-50"
      style="color: rgb(0, 180, 230)"
    >
      <div class="spinner-border text-blue" role="status"></div>
    </div>
  }
} @else {
  <div
    class="container-fluid d-flex align-items-center justify-content-center min-vh-100 bg-light"
  >
    <div class="col-md-8 col-lg-6">
      <div class="text-center mb-4">
        <img
          src="https://www.sigvaris.com/globalassets/_div/sig9000_sigvaris_group_160th_logo_dual_horizontal_darkblue_rgb.svg?ref=FD8B1C8BB4"
          alt="Sigvaris Group Logo"
          class="img-fluid mb-3"
          style="max-width: 200px; height: 120px"
        />
      </div>

      <div class="card custom-card">
        <div class="card-body" style="padding-left: 25px; padding-right: 25px">
          <h2 class="card-title text-center mb-4">Registration Successful</h2>

          <div class="text-center mb-4">
            @if (isInviteFlow) {
              <!-- Therapist invite: account is already active — no email step needed -->
              <p class="lead">Your account is now active.</p>
              <p>You can <a routerLink="/">log in</a> and start creating orders for your clinic.</p>
            } @else {
              <p class="lead">
                Thank you for registering! Your account has been created successfully.
              </p>
              <p class="lead">An activation email has just been sent to you.</p>
              <p>Open it and follow the link to activate your account.</p>
            }
            <p class="text-muted mt-3">Redirecting to login in {{ countdown }} seconds...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
}
